import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash/fp';
import request from 'utils/request_ajax';
import QuestionPrompt from 'components/Practice/Learner/QuestionPrompt';
import QuestionElementPrompt from 'components/Questions/shared/QuestionElementPrompt';
import HighFiveShareableLink from 'components/shared/HighFiveShareableLink';
import WrittenResponseQuestion from './Written/WrittenResponseQuestion';

const PracticeQuestion = props => {
  const { meta, data } = props;
  const { questionType, givenAnswer } = data;
  const [answerPresent, setAnswerPresent] = useState(!!givenAnswer);

  const saveAnswer = debounce(300)((tempData, stringify = false) => {
    const answer = stringify ? JSON.stringify(tempData) : tempData;
    const answerData = { answer, question_id: data.questionId };
    request.post(meta.saveUrl, answerData).then(() => {
      setAnswerPresent(!!answer);
    });
  });
  const isDisabled = meta.previewing || meta.finished;

  const renderBody = () => {
    switch (questionType) {
      case 'written_response':
        return (
          <WrittenResponseQuestion
            data={data}
            meta={meta}
            saveAnswer={saveAnswer}
            isDisabled={isDisabled}
          />
        );
      default:
        return <div />;
    }
  };

  return (
    <div className="bdrs-base PracticeQuestion">
      <QuestionElementPrompt
        required={data.required}
        subject={data.subject}
        questionSubjectClass={meta.questionSubjectClass}
        labelErrorClass={meta.labelErrorClass}
        isGradable={data.isGradable}
        elementHeaderClass={meta.elementHeaderClass}
        isPractice={data.isPractice}
      />
      {meta.features.practice && data.criteria.length > 0 && (
        <QuestionPrompt criteria={data.criteria} features={meta.features} />
      )}
      {renderBody()}
      <div className="p-32 pt-0">
        <HighFiveShareableLink
          questionId={data.questionId}
          progressId={data.progressId}
          hasAnswerBeenSubmitted={answerPresent}
          isGradable={data.isGradable}
        />
      </div>
    </div>
  );
};

PracticeQuestion.propTypes = {
  meta: PropTypes.shape({
    features: PropTypes.shape({
      practice: PropTypes.bool,
    }),
    finished: PropTypes.bool,
    previewing: PropTypes.bool,
    saveUrl: PropTypes.string,
  }),
  data: PropTypes.shape({
    isGradable: PropTypes.bool,
    questionId: PropTypes.number,
    progressId: PropTypes.number,
    questionType: PropTypes.string,
    required: PropTypes.bool,
    subject: PropTypes.string,
    isPractice: PropTypes.bool,
  }),
};

export default props => <PracticeQuestion {...props} />;
